import { Popover, Tooltip } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { SubMenuWrapper, StyledName, TextLink } from '../Styles/Styles';
import useClickOutside from '../../../../hooks/useClickOutside/useClickOutside';
import profilePic from "../../../Images/icons/profile-pic.png";

const permission = JSON.parse(localStorage.getItem("permissions")) || [];
const user = JSON.parse(localStorage.getItem("user"))

const logAccess = permission.find((o) => o.slug === "logs");

const MyProfileSubMenu = () => {

    const hasReadPermissionForLogs = logAccess?.permissions?.find((o) => o.slug === "read")

    const { first_name, last_name, pseudo, profile_picture_url } = user ?? {}

    const popoverRef = useRef(null);
    const isOutsideClicked = useClickOutside(popoverRef);

    const [anchorEl, setAnchorEl] = useState(null);

    const [userName, _userName] = useState("");

    useEffect(() => {
        if (first_name || last_name) {
            _userName(`${first_name !== null ? first_name : ""} ${last_name !== null ? last_name : ""}`);
        } else {
            _userName(pseudo);
        }
    }, [first_name, last_name, pseudo]);

    useEffect(() => {
        if (isOutsideClicked) {
            handleClose();
        }
    }, [isOutsideClicked])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Tooltip title='Legal Documents' placement="right">
                <img src={profile_picture_url ?? profilePic} alt={userName} onClick={handleClick} className='my-profile' />
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'center',
                    horizontal: 'left',
                }}
                ref={popoverRef}
            >
                <SubMenuWrapper>
                    <StyledName>
                        {userName.charAt(0).toUpperCase() + userName.slice(1)}
                    </StyledName>
                    <TextLink
                        to="/change-password"
                        onClick={handleClose}
                    >
                        Reset Password
                    </TextLink>
                    {hasReadPermissionForLogs && (
                        <TextLink
                            to="/server-logs"
                            onClick={handleClose}
                        >
                            Server Logs
                        </TextLink>
                    )}
                </SubMenuWrapper>
            </Popover>
        </>
    )
}

export default MyProfileSubMenu